// extracted by mini-css-extract-plugin
export default {"table":"Experiance_table__idan-"};